import UseCase from './base';

abstract class Subscription<Param = void, Result = void> extends UseCase<Param, Result> {
  readonly = false;

  abstract close(): void;
}

export default Subscription;
